<template>
  <div>
    <BrowserItem
      :item="{
        label: category.name
      }"
      arrowLeft
      :expanded="expanded"
      :borderTop="index === 0"
      @click="expanded = !expanded"
    />
    <div v-if="expanded">
      <BrowserItem
        v-for="{ servicePackage, item } in packageItems"
        :key="`package-${servicePackage.id}`"
        :item="item"
        showFavorite
        indented
        v-test="'register-browser-service-package'"
        @click="addServicePackage(servicePackage)"
      />
      <BrowserItem
        v-for="(service, index) in services"
        :key="index"
        :item="service"
        showFavorite
        indented
        @click="selectItem(service.id)"
      />
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useRegisterOrderStore } from '@/modules/register/stores/order';
import { useServicesStore } from '@/stores/services';
import type { ServicePackage } from '@/types';
import BrowserItem from '../../BrowserItem.vue';

const props = defineProps<{
  category: any;
  servicePackages: ServicePackage[];
  index: number;
}>();

const expanded = ref(false);

const { addServicePackage } = useRegisterOrderStore();

const packageItems = computed(() =>
  props.servicePackages.map((servicePackage) => ({
    servicePackage,
    item: {
      id: servicePackage.id,
      label: servicePackage.name,
      price: servicePackage.price,
      type: 'service_package',
    },
  })),
);

const services = computed(() => {
  const { services } = useServicesStore();
  return services
    .filter((service) => service.category.id === props.category.id)
    .map((item: any) => ({
      id: item.id,
      label: item.name,
      price: item.price,
      favorite: item.favorite,
      type: 'service',
    }));
});

const selectItem = (id: number) => {
  const { services } = useServicesStore();
  const service = services.find((service: any) => service.id === id);
  if (service) {
    const { addItem } = useRegisterOrderStore();

    addItem({
      name: service.name,
      price: service.price,
      serviceId: service.id,
      medical: service.medical!,
    });
  }
};
</script>
